import { Favorite as FavoriteIcon } from '@shared/assets';
import * as st from './styles.module.scss';

type Props = {
  isFavorite: boolean;
};

export const Favorite: React.FC<Props> = ({ isFavorite }) => {
  return (
    <>
      {isFavorite && (
        <div className={st.favorite}>
          <FavoriteIcon />
        </div>
      )}
    </>
  );
};
